<ng-content></ng-content>
@if (showDownloadOptions) {
  @if (allowHtml) {
    <button
      mat-flat-button
      type="button"
      (click)="onDownloadHtml()"
      matTooltip="Download as HTML"
      [disabled]="isLoading"
      >
      HTML
      <mat-icon>get_app</mat-icon>
    </button>
  }
  @if (allowPdf) {
    <button
      mat-flat-button
      type="button"
      (click)="onDownloadPdf()"
      matTooltip="Download as PDF"
      [disabled]="isLoading"
      >
      PDF
      <mat-icon>get_app</mat-icon>
    </button>
  }
  @if (allowExcel) {
    <button
      mat-flat-button
      type="button"
      (click)="onDownloadExcel()"
      matTooltip="Download as Excel"
      [disabled]="isLoading"
      >
      Excel
      <mat-icon>get_app</mat-icon>
    </button>
  }
  <button mat-flat-button type="button" (click)="onPrint()" matTooltip="Print">
    <mat-icon>print</mat-icon>
  </button>
}
@if (allowConfigure) {
  <button mat-flat-button type="button" (click)="onConfigure()" matTooltip="Configure Report">
    <mat-icon>settings</mat-icon>
  </button>
}
@if (allowMemorize) {
  <button
    mat-flat-button
    type="button"
    (click)="onSaveParameters()"
    matTooltip="Save Report Parameters"
    >
    <mat-icon>save</mat-icon>
  </button>
}
